import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkingFacilityCountsFetchFailedAction = {
	type: 'WORKING_FACILITY_COUNTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkingFacilityCountsFetchFailedAction => ({
	type: 'WORKING_FACILITY_COUNTS_FETCH_FAILED',
	payload,
});
